export const hasLicenseNumberRequirement = (licenseCode?: string): boolean =>
  !!licenseCode && ['01', '28'].includes(licenseCode);
